import JSZip from 'jszip'
import { saveAs } from 'file-saver'
// NOTE: 拡張子を .pem.txt にしているのは Vite dev サーバの server.fs.deny が
// デフォルトで *.pem の配信を 403 にするため（zip 内では AmazonRootCA1.pem に戻す）
import rootCaPem from '@/assets/AmazonRootCA1.pem.txt?raw'
import type { CertificatePemResult, IssueDeviceResult } from '@/types/device'

// fork_webapp_backend の export-*-certs.sh が生成する3点セットと同じ構成で zip 化する
export async function downloadCertZip(result: IssueDeviceResult) {
  const readme = [
    `Device certificate bundle for ${result.deviceName}`,
    '',
    `Device name (MQTT client ID): ${result.deviceName}`,
    `Site ID:                      ${result.siteId}`,
    `Device type:                  ${result.deviceType}`,
    `IoT policy:                   ${result.policyName}`,
    `Certificate ID:               ${result.certificateId}`,
    `MQTT endpoint (ATS):          ${result.endpoint}`,
    '',
    'Files:',
    '  certificate.pem   - Device certificate',
    '  private.key       - Private key (keep secret, never commit)',
    '  AmazonRootCA1.pem - Amazon Root CA 1',
    '',
    'Connection example:',
    `  mosquitto_pub -h ${result.endpoint} -p 8883 \\`,
    '    --cert certificate.pem --key private.key --cafile AmazonRootCA1.pem \\',
    `    -i ${result.deviceName} -t fork/${result.siteId}/test -m hello`,
    '',
  ].join('\n')

  const zip = new JSZip()
  zip.file('certificate.pem', result.certificatePem)
  zip.file('private.key', result.privateKey)
  zip.file('AmazonRootCA1.pem', rootCaPem)
  zip.file('README.txt', readme)

  const blob = await zip.generateAsync({ type: 'blob' })
  saveAs(blob, `${result.deviceName}-certs.zip`)
}

// 発行済み証明書の再ダウンロード。発行時に SSM へ保管した秘密鍵があれば
// private.key も含める（保管開始前に発行された証明書は証明書PEMのみ）
export async function downloadCertPemZip(
  device: { deviceName: string; siteId: string | null },
  result: CertificatePemResult
) {
  const hasKey = Boolean(result.privateKey)
  const readme = [
    `Device certificate for ${device.deviceName} (re-download)`,
    '',
    `Device name (MQTT client ID): ${device.deviceName}`,
    `Site ID:                      ${device.siteId ?? '-'}`,
    `Certificate ID:               ${result.certificateId}`,
    `Certificate status:           ${result.status}`,
    `MQTT endpoint (ATS):          ${result.endpoint}`,
    '',
    'Files:',
    '  certificate.pem   - Device certificate',
    ...(hasKey
      ? ['  private.key       - Private key (keep secret, never commit)']
      : []),
    '  AmazonRootCA1.pem - Amazon Root CA 1',
    '',
    ...(hasKey
      ? []
      : [
          'NOTE: private.key is NOT included. This certificate was issued before',
          'private keys were stored, so the key was only available at issuance.',
          'If the key is lost, deactivate this certificate and issue a new one.',
          '',
        ]),
  ].join('\n')

  const zip = new JSZip()
  zip.file('certificate.pem', result.certificatePem)
  if (result.privateKey) zip.file('private.key', result.privateKey)
  zip.file('AmazonRootCA1.pem', rootCaPem)
  zip.file('README.txt', readme)

  const blob = await zip.generateAsync({ type: 'blob' })
  saveAs(blob, `${device.deviceName}-cert${hasKey ? 's' : ''}.zip`)
}
